module.exports = __webpack_public_path__ + "static/media/N20.ce45f32e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/N20.svg
// module id = 195
// module chunks = 0